var map = {
	"./apple-pay.svg": 425,
	"./arrow-down-inside-circle-omnidrive.svg": 426,
	"./arrow-down-inside-circle.svg": 427,
	"./arrow-down.svg": 428,
	"./arrow-downwards.svg": 429,
	"./arrow-left.svg": 430,
	"./arrow-right.svg": 431,
	"./arrow-up-inside-circle-omnidrive.svg": 432,
	"./arrow-up-inside-circle.svg": 433,
	"./arrow-upwards.svg": 434,
	"./arrows.svg": 435,
	"./bank-id-sweden.svg": 436,
	"./bank.svg": 437,
	"./bankid.svg": 438,
	"./bitcoin-logo.svg": 439,
	"./boleto.svg": 440,
	"./brazil.svg": 441,
	"./buy.svg": 442,
	"./calendar.svg": 443,
	"./card.svg": 444,
	"./check-circle.svg": 445,
	"./chevron-down.svg": 446,
	"./chevron-left.svg": 447,
	"./chevron-right.svg": 448,
	"./clock.svg": 449,
	"./close.svg": 450,
	"./copy.svg": 451,
	"./dash.svg": 452,
	"./denmark.svg": 453,
	"./download.svg": 454,
	"./estonia.svg": 455,
	"./eu.svg": 456,
	"./eye.svg": 457,
	"./fail.svg": 458,
	"./finland.svg": 459,
	"./google-pay.svg": 460,
	"./info.svg": 461,
	"./input-valid.svg": 462,
	"./logout.svg": 463,
	"./magnifying-glass.svg": 464,
	"./mastercard.svg": 465,
	"./mit-id.svg": 466,
	"./norway.svg": 467,
	"./null.svg": 468,
	"./overview.svg": 469,
	"./pix.svg": 470,
	"./plus.svg": 471,
	"./radio-active-omnidrive.svg": 472,
	"./radio-active.svg": 473,
	"./radio-deactivated-omnidrive.svg": 474,
	"./radio-deactivated.svg": 475,
	"./radio-unchecked.svg": 476,
	"./sell.svg": 477,
	"./settings.svg": 478,
	"./smart-id.svg": 479,
	"./success.svg": 480,
	"./sweden.svg": 481,
	"./switch-arrows.svg": 482,
	"./transactions.svg": 483,
	"./transfer.svg": 484,
	"./trash.svg": 485,
	"./triangle-down.svg": 486,
	"./triangle-up.svg": 487,
	"./trustly.svg": 488,
	"./user.svg": 489,
	"./valid.svg": 490,
	"./visa.svg": 491,
	"./volt.svg": 492,
	"./wallet.svg": 493,
	"./warning.svg": 494
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 424;